/* unplugin-vue-components disabled */import script from "./TransferOfferNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferOfferNotification.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__